import { SVGProps } from 'react'

export const ArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" fill="none" viewBox="0 0 8 4" {...props}>
    <path fill="currentColor" d="M8 4L4 0L0 4L8 4Z"></path>
  </svg>
)
